<template>
  <div class="alarmDetail">
    <div class="table flex-center ">
      <div class="table-header">
        <el-button type="primary" class="header-btn"
                   @click="()=>{$router.go(-1)}">返回</el-button>
      </div>
      <div class="ioc-table">
        <el-scrollbar style="height:90%">
        <ioc-table ref="alarmTab"
                   :data="alarmData"
                   :option="alarmOption"
                   :page="alarmPage"
                   @current-change="selectPage"
                   @size-change="changeSize">

        </ioc-table>
        </el-scrollbar>
      </div>

    </div>
  </div>
</template>
<script>
import { alarmOption} from '../const/alarmDetail'
import utils from '@src/common/utils'
import { api } from '../api'
export default {
  data () {
    return {
      tableOption: alarmOption(this),
      alarmData: [],
      thirdDeviceId: '',
      // 分页属性设置
      alarmPage: {
        pageNum:1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') ||10,
      },
    }
  },
  created () {
    this.queryAlarmData();
  },
  mounted () {
  },
  methods: {
    goBack () {

    },
    queryAlarmData () {
      const params = {
        pageNum: this.alarmPage.pageNum,
        pageSize: this.alarmPage.pageSize,
        thirdDeviceId: this.$route.query.alarm.thirdDeviceId,
      }
      this.$fetch(api.electricDevice.queryElectricalFireAlarmInfo, params).then((res) => {
        if (res.success) {
          this.alarmData = res.returnObj.list;
          this.alarmPage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      })
    },
    //  changeSize (val) {
    //   console.log(val,'======val')
    //   this.getDevPra.pageSize = val;
    //   this.getDevPra.page = 1;
    //   this.getDevPra.deviceType = this.checkDevType;
    //   if (!this.clickSearch || !this.isArea) {
    //     this.getDevPra.isArea = this.isArea = '';
    //   }
    //   this.devicePage.pageSize = val;
    //   this.devicePage.currentPage = 1;
    //   this.getDevList();
    // },
    changeSize (val) {
      console.log(val, '======va111le')
      this.alarmPage.pageSize = val;
      this.alarmPage.pageNum = 1;
      this.queryAlarmData();
    },
    // 点击上一页下一页按钮
    selectPage (val) {
      console.log(val,'=========val')
      this.alarmPage.pageNum = val;
      this.queryAlarmData();
    },
  }
}
</script>
<style lang="scss">
.table {
  height:700px;
  position: relative;
  display: flex;
  flex-direction: column;
  .table-header{
    margin-top: 20px;
  }
  .header-btn{
    float: right;
    padding-right: 20px;
  }
  //   margin-top: 20px;
  // }
  // .el-pagination{
  //   margin-bottom: 30px;
  // }
  // .ioc-table__content{
  //   height: 800px;
  // }
  .ioc-table__pagination {
    width: 420px;
    position: absolute;
    bottom: 0px;
    left: 50%;
    margin-left: -210px;
  }
}
</style>
